// extracted by mini-css-extract-plugin
export default {"loading":"PageLoading_loading__FfyzH","spinner":"PageLoading_spinner__Bqysn","spin":"PageLoading_spin__p0WIJ"};